interface FlatMenuItem {
  id: string;
  idCha: string | null;
  title: string;
  icon?: string;
  path?: string;
}

interface NestedMenuItem extends FlatMenuItem {
  children?: NestedMenuItem[];
}

export function renderSidebarMenu(type: 'admin' | 'user' = 'admin') {
  const sidebarMenuEl = document.getElementById(type == 'user' ? 'sidebar' : 'sidebarMenu');
  if (!sidebarMenuEl) return;

  // ===== NHÁNH USER: lấy menu từ localStorage, render dạng "side-item" phẳng =====
  if (type === 'user') {
    try {
      const userStr = localStorage.getItem('user');
      if (!userStr) {
        console.warn('Không tìm thấy thông tin user trong localStorage');
        return;
      }

      const userData = JSON.parse(userStr);
      const flatMenus: FlatMenuItem[] = userData.menus || [];

      const searchHtml = `
        <div class="side-search">
          <input type="text" id="menu-search-input" placeholder="Tìm kiếm..." />
        </div>
      `;

      if (flatMenus.length === 0) {
        sidebarMenuEl.innerHTML = searchHtml + '<div class="side-item">Không có quyền menu</div>';
        return;
      }

      const currentPath = window.location.pathname;

      const itemsHtml = flatMenus.map(item => {
        const path = item.path || '#';
        const isActive = currentPath === path;
        const activeClass = isActive ? ' active' : '';
        const iconHtml = item.icon ? `<span class="ic">${item.icon}</span> ` : '';

        return `
          <div class="side-item${activeClass}" data-name="${item.title}">
            <a href="${path}">
              ${iconHtml}${item.title}
            </a>
          </div>
        `;
      }).join('');

      sidebarMenuEl.innerHTML = searchHtml + itemsHtml;
    } catch (error) {
      console.error('Lỗi khi render menu user từ localStorage:', error);
    }
    return;
  }

  // ===== NHÁNH ADMIN: giữ nguyên logic cũ (menu phẳng -> cây) =====
  try {
    // 1. Lấy dữ liệu user từ localStorage
    const userStr = localStorage.getItem('user');
    if (!userStr) {
      console.warn('Không tìm thấy thông tin user trong localStorage');
      return;
    }

    const userData = JSON.parse(userStr);
    const flatMenus: FlatMenuItem[] = userData.menus || [];

    if (flatMenus.length === 0) {
      sidebarMenuEl.innerHTML = '<li class="menu-item"><span class="menu-link">Không có quyền menu</span></li>';
      return;
    }

    // 2. Thuật toán chuyển mảng phẳng (Flat) thành mảng phân cấp (Nested Tree)
    const buildTree = (items: FlatMenuItem[]): NestedMenuItem[] => {
      const map = new Map<string, NestedMenuItem>();
      const roots: NestedMenuItem[] = [];

      // Khởi tạo map bản ghi
      items.forEach(item => {
        map.set(item.id, { ...item, children: [] });
      });

      // Gắn kết con vào cha
      items.forEach(item => {
        const node = map.get(item.id)!;
        if (item.idCha) {
          const parent = map.get(item.idCha);
          if (parent) {
            parent.children!.push(node);
          }
        } else {
          roots.push(node);
        }
      });

      return roots;
    };

    const menuTree = buildTree(flatMenus);

    // 3. Hàm sinh chuỗi HTML từ cây dữ liệu
    const generateMenuHTML = (items: NestedMenuItem[]): string => {
      return items.map(item => {
        const hasSub = item.children && item.children.length > 0;
        const iconHtml = item.icon ? `<i class="${item.icon}"></i> ` : '';
        const path = item.path || '#';

        if (hasSub) {
          return `
            <li class="menu-item has-submenu">
              <a href="${path}" class="menu-link">
                <span>${iconHtml}${item.title}</span>
                <i class="fa-solid fa-chevron-down chevron"></i>
              </a>
              <ul class="submenu">
                ${generateSubmenuHTML(item.children!)}
              </ul>
            </li>
          `;
        } else {
          return `
            <li class="menu-item">
              <a href="${path}" class="menu-link">
                <span>${iconHtml}${item.title}</span>
              </a>
            </li>
          `;
        }
      }).join('');
    };

    const generateSubmenuHTML = (subItems: NestedMenuItem[]): string => {
      return subItems.map(sub => {
        const subIcon = sub.icon ? `<i class="${sub.icon}"></i>` : `<i class="fa-regular fa-circle submenu-dot"></i>`;
        return `
          <li class="submenu-item">
            <a href="${sub.path || '#'}" class="submenu-link">
              <span>${subIcon} ${sub.title}</span>
            </a>
          </li>
        `;
      }).join('');
    };

    // 4. Đổ dữ liệu vào DOM
    sidebarMenuEl.innerHTML = generateMenuHTML(menuTree);

  } catch (error) {
    console.error('Lỗi khi render menu phẳng từ localStorage:', error);
  }
}